import React from "react";
import { ArrowUp } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-16" style={{ background: 'var(--text-primary)' }}>
      <div className="container">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="font-mono text-lg font-semibold mb-4" style={{ color: 'white' }}>
              aithatwows.com
            </div>
            <p className="body-medium mb-6" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              AI that truly wows - transforming businesses with intelligent automation. 
              From lead qualification to project delivery, we deliver results that amaze.
            </p>
            <div className="flex gap-4">
              <button className="btn-secondary">
                Contact Us
              </button>
              <button 
                onClick={scrollToTop}
                className="btn-nav"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white' 
                }}
              >
                <ArrowUp size={16} />
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3 mb-4" style={{ color: 'white' }}>Services</h4>
            <ul className="space-y-2">
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>AI Implementation</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Process Automation</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Data Analysis</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Custom Solutions</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Ongoing Support</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="heading-3 mb-4" style={{ color: 'white' }}>Company</h4>
            <ul className="space-y-2">
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>About Us</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Case Studies</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Blog</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Careers</a></li>
              <li><a href="/coming-soon" className="body-small hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="pt-8 border-t flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}
        >
          <div className="mono-text" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            © 2025 aithatwows.com. All rights reserved.
          </div>
          <div className="flex gap-6">
            <a href="/coming-soon" className="caption hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              Privacy Policy
            </a>
            <a href="/coming-soon" className="caption hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              Terms of Service
            </a>
            <a href="/coming-soon" className="caption hover:opacity-70 transition-opacity" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;